import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from "axios";
import qs from 'qs';
import HomePage from '../views/HomePage.vue'

Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: {
      TempCher: true
    }
  },
  
  {
    path: '/PersCent',
    name: 'PersCent',
    // route level code-splitting
    // this generates a separate chunk (PersCent.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "PersCent" */ '../views/PersCent.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/outlets',
    name: 'outlets',
    // route level code-splitting
    // this generates a separate chunk (outlets.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "outlets" */ '../views/outlets.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/payment',
    name: 'payment',
    // route level code-splitting
    // this generates a separate chunk (payment.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "payment" */ '../views/payment.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/CardBag',
    name: 'CardBag',
    // route level code-splitting
    // this generates a separate chunk (CardBag.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "CardBag" */ '../views/CardBag.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/CardDetails',
    name: 'CardDetails',
    // route level code-splitting
    // this generates a separate chunk (CardDetails.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "CardDetails" */ '../views/CardDetails.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/NewCape',
    name: 'NewCape',
    // route level code-splitting
    // this generates a separate chunk (NewCape.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "NewCape" */ '../views/NewCape.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/GetCard',
    name: 'GetCard',
    // route level code-splitting
    // this generates a separate chunk (GetCard.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "GetCard" */ '../views/GetCard.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/BindCard',
    name: 'BindCard',
    // route level code-splitting
    // this generates a separate chunk (BindCard.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "BindCard" */ '../views/BindCard.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/ApplCard',
    name: 'ApplCard',
    // route level code-splitting
    // this generates a separate chunk (ApplCard.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ApplCard" */ '../views/ApplCard.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/MyBill',
    name: 'MyBill',
    // route level code-splitting
    // this generates a separate chunk (MyBill.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "MyBill" */ '../views/MyBill.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/BillDetails',
    name: 'BillDetails',
    // route level code-splitting
    // this generates a separate chunk (BillDetails.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "BillDetails" */ '../views/BillDetails.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/PlayOpel',
    name: 'PlayOpel',
    // route level code-splitting
    // this generates a separate chunk (PlayOpel.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "PlayOpel" */ '../views/PlayOpel.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/SelectCard',
    name: 'SelectCard',
    // route level code-splitting
    // this generates a separate chunk (SelectCard.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "SelectCard" */ '../views/SelectCard.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/ExchCord',
    name: 'ExchCord',
    // route level code-splitting
    // this generates a separate chunk (ExchCord.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ExchCord" */ '../views/ExchCord.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/AgstOpel',
    name: 'AgstOpel',
    // route level code-splitting
    // this generates a separate chunk (AgstOpel.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "AgstOpel" */ '../views/AgstOpel.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/balance',
    name: 'balance',
    // route level code-splitting
    // this generates a separate chunk (balance.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "balance" */ '../views/balance.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/integral',
    name: 'integral',
    // route level code-splitting
    // this generates a separate chunk (integral.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "integral" */ '../views/integral.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/PoinDels',
    name: 'PoinDels',
    // route level code-splitting
    // this generates a separate chunk (PoinDels.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "PoinDels" */ '../views/PoinDels.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/TranActs',
    name: 'TranActs',
    // route level code-splitting
    // this generates a separate chunk (TranActs.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "TranActs" */ '../views/TranActs.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/cardnber',
    name: 'cardnber',
    // route level code-splitting
    // this generates a separate chunk (cardnber.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "cardnber" */ '../views/cardnber.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/TranPost',
    name: 'TranPost',
    // route level code-splitting
    // this generates a separate chunk (TranPost.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "TranPost" */ '../views/TranPost.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/PurcCard',
    name: 'PurcCard',
    // route level code-splitting
    // this generates a separate chunk (PurcCard.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "PurcCard" */ '../views/PurcCard.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/hotel',
    name: 'hotel',
    // route level code-splitting
    // this generates a separate chunk (hotel.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "hotel" */ '../views/hotel.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/HousPrty',
    name: 'HousPrty',
    // route level code-splitting
    // this generates a separate chunk (HousPrty.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "HousPrty" */ '../views/HousPrty.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/MessCent',
    name: 'MessCent',
    // route level code-splitting
    // this generates a separate chunk (MessCent.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "MessCent" */ '../views/MessCent.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/InfoDeta',
    name: 'InfoDeta',
    // route level code-splitting
    // this generates a separate chunk (InfoDeta.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "InfoDeta" */ '../views/InfoDeta.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/service',
    name: 'service',
    // route level code-splitting
    // this generates a separate chunk (service.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "service" */ '../views/service.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/address',
    name: 'address',
    // route level code-splitting
    // this generates a separate chunk (address.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "address" */ '../views/address.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/signin',
    name: 'signin',
    // route level code-splitting
    // this generates a separate chunk (signin.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "signin" */ '../views/signin.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/register',
    name: 'register',
    // route level code-splitting
    // this generates a separate chunk (register.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "register" */ '../views/register.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/restpard',
    name: 'restpard',
    // route level code-splitting
    // this generates a separate chunk (restpard.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "restpard" */ '../views/restpard.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/paytword',
    name: 'paytword',
    // route level code-splitting
    // this generates a separate chunk (paytword.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "paytword" */ '../views/paytword.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/setup',
    name: 'setup',
    // route level code-splitting
    // this generates a separate chunk (setup.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "setup" */ '../views/setup.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/Acotseup',
    name: 'Acotseup',
    // route level code-splitting
    // this generates a separate chunk (Acotseup.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Acotseup" */ '../views/Acotseup.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/Nickment',
    name: 'Nickment',
    // route level code-splitting
    // this generates a separate chunk (Nickment.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Nickment" */ '../views/Nickment.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/realtion',
    name: 'realtion',
    // route level code-splitting
    // this generates a separate chunk (realtion.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "realtion" */ '../views/realtion.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/Mobiment',
    name: 'Mobiment',
    // route level code-splitting
    // this generates a separate chunk (Mobiment.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Mobiment" */ '../views/Mobiment.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/Aboutus',
    name: 'Aboutus',
    // route level code-splitting
    // this generates a separate chunk (Aboutus.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Aboutus" */ '../views/Aboutus.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/secutr',
    name: 'secutr',
    // route level code-splitting
    // this generates a separate chunk (secutr.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "secutr" */ '../views/secutr.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/chinword',
    name: 'chinword',
    // route level code-splitting
    // this generates a separate chunk (chinword.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "chinword" */ '../views/chinword.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/details',
    name: 'details',
    // route level code-splitting
    // this generates a separate chunk (details.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "details" */ '../views/details.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/paymthod',
    name: 'paymthod',
    // route level code-splitting
    // this generates a separate chunk (paymthod.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "paymthod" */ '../views/paymthod.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/Promarge',
    name: 'Promarge',
    // route level code-splitting
    // this generates a separate chunk (Promarge.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Promarge" */ '../views/Promarge.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/userment',
    name: 'userment',
    // route level code-splitting
    // this generates a separate chunk (userment.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "userment" */ '../views/userment.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/privolcy',
    name: 'privolcy',
    // route level code-splitting
    // this generates a separate chunk (privolcy.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "privolcy" */ '../views/privolcy.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/ticelaon',
    name: 'ticelaon',
    // route level code-splitting
    // this generates a separate chunk (ticelaon.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ticelaon" */ '../views/ticelaon.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/olvapicy',
    name: 'olvapicy',
    // route level code-splitting
    // this generates a separate chunk (olvapicy.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "olvapicy" */ '../views/olvapicy.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/thirpaty',
    name: 'thirpaty',
    // route level code-splitting
    // this generates a separate chunk (thirpaty.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "thirpaty" */ '../views/thirpaty.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/hospital',
    name: 'hospital',
    // route level code-splitting
    // this generates a separate chunk (hospital.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "hospital" */ '../views/hospital.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/repore',
    name: 'repore',
    // route level code-splitting
    // this generates a separate chunk (repore.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "repore" */ '../views/repore.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/makent',
    name: 'makent',
    // route level code-splitting
    // this generates a separate chunk (makent.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "makent" */ '../views/makent.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/Fillon',
    name: 'Fillon',
    // route level code-splitting
    // this generates a separate chunk (Fillon.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Fillon" */ '../views/Fillon.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/tislot',
    name: 'tislot',
    // route level code-splitting
    // this generates a separate chunk (tislot.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "tislot" */ '../views/tislot.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/verion',
    name: 'verion',
    // route level code-splitting
    // this generates a separate chunk (verion.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "verion" */ '../views/verion.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/medirt',
    name: 'medirt',
    // route level code-splitting
    // this generates a separate chunk (medirt.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "medirt" */ '../views/medirt.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/choact',
    name: 'choact',
    // route level code-splitting
    // this generates a separate chunk (choact.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "choact" */ '../views/choact.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/shopmall',
    name: 'shopmall',
    // route level code-splitting
    // this generates a separate chunk (shopmall.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "shopmall" */ '../views/shopmall.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/hosphome',
    name: 'hosphome',
    // route level code-splitting
    // this generates a separate chunk (hosphome.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "hosphome" */ '../views/hosphome.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/phyexcon',
    name: 'phyexcon',
    // route level code-splitting
    // this generates a separate chunk (phyexcon.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "phyexcon" */ '../views/phyexcon.vue'),
    meta: {
      TempCher: false
    }
  },

  {
    path: '/commodity',
    name: 'commodity',
    // route level code-splitting
    // this generates a separate chunk (commodity.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "commodity" */ '../views/commodity.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/NewAddress',
    name: 'NewAddress',
    // route level code-splitting
    // this generates a separate chunk (NewAddress.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "NewAddress" */ '../views/NewAddress.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/Fillrder',
    name: 'Fillrder',
    // route level code-splitting
    // this generates a separate chunk (Fillrder.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Fillrder" */ '../views/Fillrder.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/Seleress',
    name: 'Seleress',
    // route level code-splitting
    // this generates a separate chunk (Seleress.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Seleress" */ '../views/Seleress.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/Ordesion',
    name: 'Ordesion',
    // route level code-splitting
    // this generates a separate chunk (Ordesion.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Ordesion" */ '../views/Ordesion.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/resevabr',
    name: 'resevabr',
    // route level code-splitting
    // this generates a separate chunk (resevabr.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "resevabr" */ '../views/resevabr.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/PaymentSuccessful',
    name: 'PaymentSuccessful',
    // route level code-splitting
    // this generates a separate chunk (PaymentSuccessful.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "PaymentSuccessful" */ '../views/PaymentSuccessful.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/Myorder',
    name: 'Myorder',
    // route level code-splitting
    // this generates a separate chunk (Myorder.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Myorder" */ '../views/Myorder.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/Wafopant',
    name: 'Wafopant',
    // route level code-splitting
    // this generates a separate chunk (Wafopant.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Wafopant" */ '../views/Wafopant.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/ShopCart',
    name: 'ShopCart',
    // route level code-splitting
    // this generates a separate chunk (ShopCart.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ShopCart" */ '../views/ShopCart.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/modtyatn',
    name: 'modtyatn',
    // route level code-splitting
    // this generates a separate chunk (modtyatn.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "modtyatn" */ '../views/modtyatn.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/pructrch',
    name: 'pructrch',
    // route level code-splitting
    // this generates a separate chunk (pructrch.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "pructrch" */ '../views/pructrch.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/seaducts',
    name: 'seaducts',
    // route level code-splitting
    // this generates a separate chunk (seaducts.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "seaducts" */ '../views/seaducts.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/ersoncal',
    name: 'ersoncal',
    // route level code-splitting
    // this generates a separate chunk (ersoncal.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "ersoncal" */ '../views/ersoncal.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/pointsal',
    name: 'pointsal',
    // route level code-splitting
    // this generates a separate chunk (pointsal.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "pointsal" */ '../views/pointsal.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/florpt',
    name: 'florpt',
    // route level code-splitting
    // this generates a separate chunk (florpt.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "florpt" */ '../views/florpt.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/shngties',
    name: 'shngties',
    // route level code-splitting
    // this generates a separate chunk (shngties.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "shngties" */ '../views/shngties.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/Actvas',
    name: 'Actvas',
    // route level code-splitting
    // this generates a separate chunk (Actvas.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Actvas" */ '../views/Actvas.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/Feedck',
    name: 'Feedck',
    // route level code-splitting
    // this generates a separate chunk (Feedck.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Feedck" */ '../views/Feedck.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/inalch',
    name: 'inalch',
    // route level code-splitting
    // this generates a separate chunk (inalch.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "inalch" */ '../views/inalch.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/peracter',
    name: 'peracter',
    // route level code-splitting
    // this generates a separate chunk (peracter.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "peracter" */ '../views/peracter.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/pacuns',
    name: 'pacuns',
    // route level code-splitting
    // this generates a separate chunk (pacuns.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "pacuns" */ '../views/pacuns.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/intebl',
    name: 'intebl',
    // route level code-splitting
    // this generates a separate chunk (intebl.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "intebl" */ '../views/intebl.vue'),
    meta: {
      TempCher: true
    }
  },

  {
    path: '/things',
    name: 'things',
    // route level code-splitting
    // this generates a separate chunk (things.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "things" */ '../views/things.vue'),
    meta: {
      TempCher: true
    }
  }

]

const router = new VueRouter({ 
  routes
})

router.beforeEach((to, from, next) => {
  if(to.meta.TempCher){
    // 从缓存里获取用户账号和密码
    const userphone = localStorage.getItem("phoneber");
    const userpassd = localStorage.getItem("password");
    if(userphone && userpassd){
      axios.post('app/oldAppLogin',qs.stringify({
        username: userphone,
        password: userpassd
      }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        if(res.data.code == '200'){
          localStorage.setItem("usertoken", res.data.data.token);
          next();
        }else if(res.data.code == '2011'){
          next('/signin');
        }else{
          next();
        }
      })
      .catch(() => {
        console.log('获取失败');
      });
    }else{
      localStorage.removeItem("usertoken");
      next('/signin')
    }
  }else{
    next();
  }
})

export default router